var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3 0h24v24H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5B7C",
    d: "M0 24v-2.001C0 17.598 3.6 14 8 14h2c4.4 0 8 3.6 8 8.001V24"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4.25,
    x: 7,
    y: 11.5,
    fill: "#EAEAEA",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.002a4.286 4.286 0 01-2-.502v.67c.003.871.757 1.577 1.687 1.58h.626c.93-.003 1.684-.709 1.687-1.58v-.67a4.286 4.286 0 01-2 .502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M11 13.465v-.531a1.69 1.69 0 00-1.688-1.684h-.625A1.69 1.69 0 007 12.934v.531a4.007 4.007 0 004 0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.875,
    cy: 6.75,
    fill: "#EAEAEA",
    rx: 5.125,
    ry: 6.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M4.25 8.25C3.56 8.248 3.002 7.732 3 7.095v-.94c.002-.637.56-1.153 1.25-1.155m9.5 3.25c.69-.002 1.248-.518 1.25-1.155v-.94c-.002-.637-.56-1.153-1.25-1.155"
  }))));
}
export default SvgProfile;